import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [customer, setCustomer] = useState(null);
    const [wallet, setWallet] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        const token = localStorage.getItem("fx_token");
        if (!token) {
            setCustomer(null);
            setWallet(null);
            setLoading(false);
            return;
        }
        try {
            const r = await api.get("/api/auth/me");
            setCustomer(r.data.customer);
            setWallet(r.data.wallet);
        } catch {
            localStorage.removeItem("fx_token");
            setCustomer(null);
            setWallet(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const logout = () => {
        localStorage.removeItem("fx_token");
        setCustomer(null);
        setWallet(null);
    };

    return (
        <AuthCtx.Provider value={{ customer, wallet, loading, refresh, logout, setCustomer, setWallet }}>
            {children}
        </AuthCtx.Provider>
    );
}

export const useAuth = () => useContext(AuthCtx);
